var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-10"},_vm._l((_vm.errors),function(error){return _c('v-alert',{key:error[0],attrs:{"outlined":"","dismissible":"","type":"error"}},[_vm._v(" "+_vm._s(error[0])+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }